import React from "react";
import MisStatusIcon from "root/s360components/Registration/MisStatusIcon";

export const MisSystemStatusIds = {
    UNSUBMITTED: null,
    NEW: 0,
    PENDING: 1,
    SUCCESSFUL: 2,
    EXTERNAL_FAIL: 3,
    INTERNAL_FAIL: 4
}

const pendingObject = (status) => {
    return {status_id: status, status_text: 'Pending', color: '#e7b416', icon: 'glyphicon-minus-sign', meaning: 'The system is working to pass on the registration data to external management systems.'};
}
export const MisSystemStatusArray = [
    {status_id: MisSystemStatusIds.UNSUBMITTED, status_text: 'MIS Writeback Status', color: '#e4e4e4', icon: 'glyphicon-question-sign', meaning: 'Registration has not been submitted.'},
    pendingObject(MisSystemStatusIds.NEW),
    pendingObject(MisSystemStatusIds.PENDING),
    {status_id: MisSystemStatusIds.SUCCESSFUL, status_text: 'Successful', color: '#2dc937', icon: 'glyphicon-ok-sign', meaning: 'The external system successfully moved registration data into the MIS system.'},
    {status_id: MisSystemStatusIds.EXTERNAL_FAIL, status_text: 'External failure', color: '#cc3232', icon: 'glyphicon-remove-sign', meaning: 'The external system was not able to move registration data into the MIS system.'},
    {status_id: MisSystemStatusIds.INTERNAL_FAIL, status_text: 'Internal failure', color: '#f17e3b', icon: 'glyphicon-remove-sign', meaning: 'School360 was not able to link the registration to the external system on submission.'}
];

/**
 *
 * @param status_id
 * @returns {JSX.Element}
 * @constructor
 */
const MisSystemWritebackStatus = ({mis_writeback_id, mis_writeback_status, registered, datetime_logged}) =>
{

    const MINUTES_THRESHOLD = 15;


    const showIconAfterTime = (datetime_logged, threshold) =>
    {
        if (datetime_logged !== null)
        {
            datetime_logged = new Date(datetime_logged);

            const timePlusThreshold = datetime_logged.setMinutes(datetime_logged.getMinutes() + threshold);

            return timePlusThreshold <= new Date();
        }
        else
        {
            return true; //Show icon anyway as most records won't have datetime on release
        }

    }

    const screenStatusIdForInternalFailure = (registered, mis_writeback_id, mis_writeback_status) =>
    {
        //No linked writeback id that was registered after the release of the mis indicator
        const registeredNoWriteback = registered === true && mis_writeback_id === null && mis_writeback_status === MisSystemStatusIds.NEW;

        //The indicator is showing meaning it should be linked to a mis system BUT there's no writeback_id linked to the class
        return registeredNoWriteback === true ? MisSystemStatusIds.INTERNAL_FAIL : mis_writeback_status;
    }

    const status_id = screenStatusIdForInternalFailure(registered, mis_writeback_id, mis_writeback_status);

    return (
        <div className='writeback-status-grid'>
            {showIconAfterTime(datetime_logged, MINUTES_THRESHOLD) === true && <MisStatusIcon status_id={status_id}/>}
        </div>
    )
}

export default MisSystemWritebackStatus;